import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const InfoBox = ({ label, value, valueColor }) => (
  <Box>
    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
        {label}
      </Typography>
    </Box>
    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
      <Typography variant="body2" sx={{ color: valueColor ?? '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
        {value}
      </Typography>
    </Box>
  </Box>
);

InfoBox.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  valueColor: PropTypes.string
};

export default InfoBox;
